import useGlobalContext from 'hooks/useGlobalContext';
import { useCallback } from 'react';

const useUserConfirmation = () => {
  const { modal } = useGlobalContext();
  const getUserConfirmation = useCallback((title, callback) => modal.confirm({
    title,
    okText: 'Yes',
    okType: 'danger',
    cancelText: 'No',
    onOk: () => callback(true),
    onCancel: () => callback(false),
  }), [modal]);

  return getUserConfirmation;
};

export const useSafeDelete = () => {
  const userConfirmation = useUserConfirmation();

  return useCallback((callback) => userConfirmation('Are you sure?', result => result && callback()), [userConfirmation]);
};

export default useUserConfirmation;
